'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '{{#each EndPageScripts}}{{{this}}}{{/each}}';
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL1RlbXBsYXRlcy9lbmRQYWdlUmVnaXN0cmF0aW9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUFlLDZDIiwiZmlsZSI6ImVuZFBhZ2VSZWdpc3RyYXRpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCAne3sjZWFjaCBFbmRQYWdlU2NyaXB0c319e3t7dGhpc319fXt7L2VhY2h9fSc7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/legacy-advertising/dist/Templates/endPageRegistration.js
// module id = 1520
// module chunks = 0